<template>
  <div class="head-wrap">
    <div class="head-container">
      <div class="head-logo">
        <span class="logo-name">开放平台</span>
        <span class="logo-bete">BETA</span>
      </div>
      <ul class="head-nav">
        <li class="nav-item">
          <router-link :to="{path: '/'}">首页</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{path: '/document'}" active-class="router-link-exact-active">文档</router-link>
        </li>
        <li class="nav-item">
          <a href="https://shimo.im/forms/3gkjJGPyhxTCWVCK/fill" target="_blank">申请接入</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Myhead",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.head-wrap {
  width: 100%;
  min-width: 1200px;
  height: 60px;
  background-color: #fff;
  .head-container {
    margin: 0 auto;
    width: 1200px;
    height: 60px;
    > .head-logo {
      float: left;
      width: 240px;
      height: 60px;
      background-image: url("../assets/images/logo.png");
      background-repeat: no-repeat;
      background-position: 30px center;
      > .logo-name {
        padding-left: 145px;
        line-height: 60px;
        font-size: 15px;
        color: #4bc227;
      }
      > .logo-bete {
        padding-left: 3px;
        vertical-align: 5px;
        font-size: 12px;
        font-weight: 500;
        color: #4bc227;
      }
    }
    > .head-nav {
      float: right;
      width: 960px;
      height: 60px;
      font-size: 0;
      text-align: left;
      > .nav-item {
        *display: inline;
        display: inline-block;
        padding: 0 25px;
        zoom: 1;
        height: 60px;
        font-size: 15px;
        line-height: 60px;
        cursor: pointer;
        a {
          display: block;
          padding: 0 25px;
          height: 60px;
          font-size: 15px;
          line-height: 60px;
          color: #666;
          &.router-link-exact-active {
            color: #4bc227;
          }
        }
      }
    }
  }
}
</style>